export const ASYNC_BUYFLOW_ROUTES = ['/tvi/buy/'];
export const NON_ASYNC_ROUTES = ['/tvi/reservation', '/tvi/instant-on'];

export const isAsyncRoute = (pathname: string) =>
  ASYNC_BUYFLOW_ROUTES.some((route) =>
    pathname.startsWith(route.replace(/\/$/, ''))
  );

export const isNonAsyncRoute = (pathname: string) =>
  NON_ASYNC_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(route + '/')
  );

// Guest routes are intentionally anonymous — even when a moving-app session
// is cached in localStorage/cookies, no consumer-app provider should forward
// those credentials or expose the stale user identity through context.
export const isGuestPathname = (pathname: string | undefined): boolean =>
  pathname?.startsWith('/guest/') ?? false;
